import React, { useEffect, useState } from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import AEATitle from "@/components/ui/aea-title/aea-title";
import StepsPop from '../../steps-pop';

export interface IPropsStep {
    columns: any,
    data: any,
}

const Details: React.FC<IPropsStep> = ({columns, data} : IPropsStep) => {
    const [dataSource, setDataSource] = useState<any>(null);
    const [dataColumns, setDataColumns] = useState<any>(null);
    const [yearDataColumns, setYearDataColumns] = useState<any>(null);
    const [itemYears, setItemYears] = useState<any>(null);

    const view: any = {
        state: {
            columns,
            dataColumns,
            data,
            setItemYears,
            setDataSource,
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    useEffect(() => {
        if(data && columns){
            let {auxCol, auxYearCol}: any = presenter.getDataColumnsStep4Res(presenter.formMasters)
            setDataColumns(auxCol)
            setYearDataColumns(auxYearCol)
        }
    }, [data, columns])
   
    return (
        <div style={{margin: '20px 0'}}>
            <AEATitle
                id={"ResultadosEsperados"}
                text={presenter.currentLabels.get("ResultadosEsperados")}
                tooltip={presenter.currentLabels.get("ResultadosEsperados")}
                placement={"auto"}
            ></AEATitle>
            {(dataColumns && dataSource && yearDataColumns) && 
                <StepsPop 
                    columns={dataColumns} yearLabel={presenter.currentLabels.get("PopAdminYears")} index={9} data={dataSource} yearsColumn={yearDataColumns} itemYears={itemYears} onSelectionChanged={presenter.onSelectionChangedStep}
                />
            }
        </div>
    )
}

export default Details;